"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_TOTAL_UPLOAD_SIZE = exports.MAX_FILE_SIZE = exports.ALLOWED_EXTENSIONS = exports.ALLOWED_FILE_TYPES = void 0;
exports.ALLOWED_FILE_TYPES = {
    '.pdf': { mimeType: 'application/pdf', category: 'document' },
    '.docx': { mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', category: 'document' },
    '.doc': { mimeType: 'application/msword', category: 'document' },
    '.xlsx': { mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', category: 'document' },
    '.xls': { mimeType: 'application/vnd.ms-excel', category: 'document' },
    '.csv': { mimeType: 'text/csv', category: 'document' },
    '.pptx': { mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation', category: 'document' },
    '.ppt': { mimeType: 'application/vnd.ms-powerpoint', category: 'document' },
    '.txt': { mimeType: 'text/plain', category: 'document' },
    '.md': { mimeType: 'text/markdown', category: 'document' },
    '.png': { mimeType: 'image/png', category: 'image' },
    '.jpg': { mimeType: 'image/jpeg', category: 'image' },
    '.jpeg': { mimeType: 'image/jpeg', category: 'image' },
    '.gif': { mimeType: 'image/gif', category: 'image' },
    '.webp': { mimeType: 'image/webp', category: 'image' },
    '.bmp': { mimeType: 'image/bmp', category: 'image' },
    '.svg': { mimeType: 'image/svg+xml', category: 'image' },
};
exports.ALLOWED_EXTENSIONS = Object.keys(exports.ALLOWED_FILE_TYPES);
/** Maximum size for a single file upload (20 MB). */
exports.MAX_FILE_SIZE = 20 * 1024 * 1024;
/** Maximum total upload size per request (50 MB). */
exports.MAX_TOTAL_UPLOAD_SIZE = 50 * 1024 * 1024;
//# sourceMappingURL=attachments.js.map